import { connect, mapProps, mapReadPretty } from '@formily/vue'
import { defineComponent, h } from 'vue-demi'
import { InputPreviewText } from '../PreviewText'
import InputPhoneView from './layout.vue'

const InputPhoneBase = defineComponent({
  name: 'InputPhone',
  props: {
    options: {
      type: Array,
      default: () => []
    }
  },
  setup (props, { attrs, slots, listeners }) {
    return () => {
      const { options = [] } = props
      return h(
        InputPhoneView,
        {
          props: { options },
          attrs: {
            ...attrs
          },
          on: listeners
        },
        []
      )
    }
  }
})

const InputPhone = connect(
  InputPhoneBase,
  mapProps({ readOnly: 'readonly' }),
  mapReadPretty(InputPreviewText)
)
export {
  InputPhoneView
}
export default InputPhone
